import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ProductBlogPost from 'Components/Product/Blog/ProductBlogPost';
import BlogPostItemList from 'Components/Blog/BlogPostItemList';
import ProductBlogPostsCarousel from 'Components/Product/Blog/ProductBlogPostsCarousel';
import 'Components/Product/Blog/ProductBlogPost.scss';

const ProductBlogPosts = ({ name, posts }) => {
  if (!posts || !posts.length) return false;

  return (
    <section className="product-blog-posts-section page-section-margin with-dots">
      <BlogPostItemList posts={posts} title={`${name} Blog Posts`} />
      <h2 className="pb-2">
        <FormattedMessage id="productblogposts.newsandfeatures" defaultMessage="News & Features" />
      </h2>
      {posts.length > 3 ?
        <ProductBlogPostsCarousel posts={posts} />
        :
        <div className="product-blog-posts-container">
          {posts.slice(0, 3).map(post =>
            <ProductBlogPost post={post} key={post.id} />,
          )}
        </div>
      }
    </section>
  );
};

ProductBlogPosts.propTypes = {
  name: PropTypes.string,
  posts: PropTypes.arrayOf(PropTypes.object),
};

ProductBlogPosts.defaultProps = {
  name: '',
  posts: [],
};

export default ProductBlogPosts;
